require("@babel/polyfill");
// require("./utils/events.ts");

import {Application} from "./application/application";
import {ComponentService} from "./service/component";
import {PinterestComponent} from "./component/pinterest";

(($) => $(() => {

    let components = new ComponentService();
    components.addComponent('.js-pinterest', PinterestComponent, 'PinterestComponent');
    new Application(components);

}))(jQuery);